
import { Plan } from "@/types/subscription";
import { supabase } from "@/lib/supabase";

/**
 * Récupère la liste des plans d'abonnement disponibles
 */
export async function fetchSubscriptionPlans(): Promise<Plan[]> {
  try {
    console.log("Tentative de récupération des plans d'abonnement...");
    
    // Requête pour récupérer les plans et les trier par prix mensuel croissant
    const { data, error } = await supabase
      .from('subscription_plans')
      .select('*')
      .order('price_monthly', { ascending: true }); // Tri par prix croissant
      
    if (error) {
      console.error('Erreur lors de la récupération des plans:', error);
      throw new Error('Impossible de récupérer les plans d\'abonnement');
    }
    
    if (!data) {
      console.warn('Aucun plan trouvé');
      return [];
    }
    
    console.log("Plans récupérés avec succès:", data);
    
    // Transformer les données brutes en objets Plan
    return data.map(plan => ({
      id: plan.id || '',
      name: plan.name || '',
      displayName: plan.display_name || '',
      description: plan.description || '',
      price: Number(plan.price_monthly) || 0,
      priceYearly: Number(plan.price_yearly) || 0,
      isPopular: Boolean(plan.is_popular),
      features: Array.isArray(plan.features) ? plan.features : [],
    }));

  } catch (error) {
    console.error('Exception lors de la récupération des plans:', error);
    throw error;
  }
}
